import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/main-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <div style={{
      marginLeft: '12rem',
      marginRight: "6rem",
      paddingTop: "10rem"
    }}>
      <h1>{`Contribution`}</h1>
      <p>{`We passionately welcome any PR to the project. `}</p>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      